/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { Sfbusinesstripdeclarationsf6 } from '../../models/Sfbusinesstripdeclarationsf6';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `Sfbusinesstripdeclarationsf6` model.
 */
@Injectable()
export class Sfbusinesstripdeclarationsf6Api extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `Sfbusinesstripdeclarationsf6`.
   */
  public getModelName() {
    return "Sfbusinesstripdeclarationsf6";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/Sfbusinesstripdeclarationsf6.ts